/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {TranslateLoader} from '@ngx-translate/core';

import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';

import {I18nManager} from './i18n.manager';

import {AuthenticationService} from '../authentication';

@Injectable()
export class WebpackTranslateLoader implements TranslateLoader {

  constructor(private httpClient: HttpClient,
              private authenticationService: AuthenticationService) {
  }

  public getTranslation(language: string): Observable<any> {
    return this.authenticationService.getToken()
      .pipe(
        switchMap((token: string) =>
          this.httpClient.get(`/repository/api/v1/global/i18n/${language}`, {
            headers: new HttpHeaders({Authorization: `Bearer ${token}`})
          })),
        map((configTranslations: Array<{ [key: string]: string }>) => {
          // merge frontend translations with config translations
          const merged = {};
          Object.assign(merged, I18nManager.getLocalTranslations(language));
          Object.assign(merged, configTranslations);
          return merged;
        })
      );
  }
}
